// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","float-window":"FloatWindow_float-window__EhmRD","dragging":"FloatWindow_dragging__41kvR"};